import React from 'react';

const treatFeatures = ['Deep Tissue Massage', 'Hot Stone Therapy', 'Herbal Compress', 'Hydrotherapy', 'Detox Programs'];

function Treatment() {
    return (
        <>

            {/* <!-- Header Banner --> */}
            <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/20.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="subtitle">Black Rock Luxury Hotel</div>
                            <div className="title">Recovery & Treatment</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Treatment section */}
            <section className="spa-section">

                {/* Intro */}
                <div className="spa-intro">
                    <div className="container">
                        <div className="spa-intro__inner">
                            <div className="spa-intro__text">
                                <div className="spa-intro__label">Restore. Renew. Rebalance.</div>
                                <h2 className="spa-intro__title">Recovery & Treatment</h2>
                                <div className="spa-intro__divider" />
                                <p className="spa-intro__desc">
                                    Whether for renewal or relaxation, our treatment programs are designed to balance mind, body, and spirit — all with Black Rock’s signature care.
                                </p>
                                <div className="spa-intro__features">
                                    {treatFeatures.map(function(f) { return (
                                        <span key={f} className="spa-intro__feature">
                                            <span className="spa-intro__feature-dot" />
                                            {f}
                                        </span>
                                    ); })}
                                </div>
                            </div>
                            <div className="spa-intro__img-stack">
                                <img src={`${process.env.PUBLIC_URL}/img/banner/12.jpg`} alt="" className="spa-intro__img spa-intro__img--top" />
                                <img src={`${process.env.PUBLIC_URL}/img/banner/13.jpg`} alt="" className="spa-intro__img spa-intro__img--bot" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Full-width image */}
                <div className="spa-fullimg">
                    <img src={`${process.env.PUBLIC_URL}/img/banner/14.jpg`} alt="" />
                    <div className="spa-fullimg__overlay">
                        <div className="spa-fullimg__quote">"Healing begins where stillness meets intention"</div>
                    </div>
                </div>

            </section>

        </>
    );
}

export default Treatment;